import { useEffect, useState } from 'react';

import API from '../../api/api';

export interface MicrosoftConfig {
  enabled: boolean;
  clientId?: string;
  tenantId?: string;
  redirectUri?: string;
}

export type Scope = 'maintainers' | 'student' | 'teacher';

/**
 * Lee la configuración de Microsoft Entra ID para el `scope` del portal actual.
 * El backend resuelve internamente el `portalKey` y devuelve `enabled:false`
 * cuando el setting global está OFF o cuando el portal específico no tiene
 * credenciales configuradas (multi-tenant per-portal).
 */
export function useMicrosoftConfig(
  scope: Scope,
): {
  config: MicrosoftConfig | null;
  loading: boolean;
} {
  const [config, setConfig] = useState<MicrosoftConfig | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    API.get<MicrosoftConfig>('/auth/microsoft-entra-id/config', {
      params: { scope },
    })
      .then((res) => {
        if (!cancelled) {
          setConfig(res.data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setConfig({ enabled: false });
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [scope]);

  return { config, loading };
}
